import React from "react";
import { Trans, withTranslation } from "react-i18next";
import i18n from "../../../i18n";

import {
  H3,
  Classes,
  Button,
  Intent,
  FormGroup,
  InputGroup,
  Checkbox,
  HTMLTable,
  Tag,
} from "@blueprintjs/core";

import {
  authenticatedGetFetch
} from "../../../utils/AuthenticatedFetch";

const maxEvent = 700;

class EventFiltersConfig extends React.Component {
  constructor(props) {
    super(props);

    const eventLookup = {};
    for (let i = 0; i < maxEvent; i++) {
      eventLookup[i] = { name: i18n.t("event" + i), selected: props.data ? (props.data.includes(i.toString())) : false };
    }

    this.state = {
      events: [],
      eventLookup: eventLookup,
      text_filter: "",
    };
  }

  componentDidMount() {
    authenticatedGetFetch("/events",
      (response) => {
        this.setState({ events: response.data });
      });
  }

  renderName(name) {
    return <div className={Classes.TEXT_LARGE}><strong>{name}</strong></div>;
  }

  getSelectedEvent(listEvent) {
    const res = [];
    Object.keys(listEvent).forEach(keys => {
      if (listEvent[keys].selected)
        res.push(keys);
    })

    return res;
  }
  callUpdateCb(listEvent) {
    if (this.props.onUpdate)
      this.props.onUpdate(this.getSelectedEvent(listEvent));
  }
  checkAll(state) {
    const data = { ...this.state.eventLookup };
    Object.keys(data).forEach((event) => data[event].selected = state);
    this.setState({ eventLookup: data });

    this.callUpdateCb(data);
  }

  render() {
    return (
      <div>
        <H3><Trans>Select events</Trans></H3>

          <div style={{ display: "flex" }}>
            <FormGroup inline={true} label={<Trans>search</Trans>} labelFor="text_filter">
              <InputGroup leftIcon="search" id="text_filter" value={this.state.text_filter} onChange={(filter) => this.setState({ text_filter: filter.target.value })} />
            </FormGroup>
            <Button
              icon="circle"
              intent={Intent.DANGER}
              style={{ margin: '1px 1px 1px 1px', height: "30px" }}
              onClick={() => {
                this.checkAll(false);
              }}
            >
            </Button>
            <Button
              icon="tick-circle"
              intent={Intent.PRIMARY}
              style={{ margin: '1px 1px 1px 1px', height: "30px" }}
              onClick={() => {
                this.checkAll(true);
              }}
            >
            </Button>
          </div>

          <div style={{ height: "75vh" }}>
            <HTMLTable striped={true} compact={true}>
              <thead>
                <tr>
                  <th><Trans>display</Trans></th>
                  <th><Trans>label</Trans></th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(this.state.eventLookup).map(event => (event[1].name.toUpperCase().includes(this.state.text_filter.toUpperCase())) ? <tr>
                  <td>
                    <Checkbox
                      checked={event[1].selected} 
                      onChange={(ti) => {
                        event[1].selected = ti.target.checked;
                        this.callUpdateCb(this.state.eventLookup);
                      }}
                    />
                  </td>
                  <td><Tag large={true} intent={this.state.events[event[0]]?.intent}> {event[1].name}</Tag></td>
                </tr> : null)}
              </tbody>
            </HTMLTable>
          </div>
      </div >);
  }
}

export default withTranslation()(EventFiltersConfig)
